var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 3 42 42",
    width: "48px",
    height: "48px"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20.5,
    fill: "white",
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0288d1",
    d: "M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 19H18V34H14zM15.988 17h-.022C14.772 17 14 16.11 14 14.999 14 13.864 14.796 13 16.011 13c1.217 0 1.966.864 1.989 1.999C18 16.11 17.228 17 15.988 17zM35 24.5c0-3.038-2.462-5.5-5.5-5.5-1.862 0-3.505.928-4.5 2.344V19h-4v15h4v-8c0-1.657 1.343-3 3-3s3 1.343 3 3v8h4C35 34 35 24.921 35 24.5z"
  })));
};

export { SvgLinkedin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjMgMyA0MiA0MiIgd2lkdGg9IjQ4cHgiIGhlaWdodD0iNDhweCI+CiAgICA8Y2lyY2xlIGN4PSIyNCIgY3k9IjI0IiByPSIyMC41IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjRThFOEU4Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDI4OGQxIiBkPSJNMjQgNEEyMCAyMCAwIDEgMCAyNCA0NEEyMCAyMCAwIDEgMCAyNCA0WiIvPgogICAgPHBhdGggZmlsbD0iI2ZmZiIKICAgICAgICAgIGQ9Ik0xNCAxOUgxOFYzNEgxNHpNMTUuOTg4IDE3aC0uMDIyQzE0Ljc3MiAxNyAxNCAxNi4xMSAxNCAxNC45OTkgMTQgMTMuODY0IDE0Ljc5NiAxMyAxNi4wMTEgMTNjMS4yMTcgMCAxLjk2Ni44NjQgMS45ODkgMS45OTlDMTggMTYuMTEgMTcuMjI4IDE3IDE1Ljk4OCAxN3pNMzUgMjQuNWMwLTMuMDM4LTIuNDYyLTUuNS01LjUtNS41LTEuODYyIDAtMy41MDUuOTI4LTQuNSAyLjM0NFYxOWgtNHYxNWg0di04YzAtMS42NTcgMS4zNDMtMyAzLTNzMyAxLjM0MyAzIDN2OGg0QzM1IDM0IDM1IDI0LjkyMSAzNSAyNC41eiIvPgo8L3N2Zz4=";